<template>
    <div style="background: #FAFAFA;">
        <div>
            <!-- Modal -->
            <div class="modal fade" id="kidDetails" tabindex="-1" aria-labelledby="kidDetails" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 @click="goBack()" class="modal-title title-modal" id="kidDetails">Kid Details</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body mt-4 container" style="background: #FAFAFA;">
                            <div class="profile-image-holder">
                                <div class="profile-image">
                                   
                                    <img v-if="activeKid && activeKid.avatar_url" :src="activeKid.avatar_url" alt="profile" style="border: 1px solid #e2e3e3;">
                                    <img v-else src="../../assets/icons/profile-icon.svg" alt="profile">
                                    <span>
                                        <!-- <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.6973 1.52246C17.1537 0.826396 18.8463 0.826398 20.3027 1.52246C20.9616 1.83736 21.5682 2.36432 22.501 3.15918C22.9074 3.50558 23.0521 3.6276 23.2012 3.72754C23.5682 3.9735 23.9806 4.14388 24.4141 4.22949C24.5901 4.26426 24.7788 4.28073 25.3115 4.32324C26.5331 4.42074 27.3349 4.47654 28.0234 4.71973C29.5454 5.25736 30.7426 6.45462 31.2803 7.97656V7.97754C31.5231 8.66581 31.5792 9.46702 31.6768 10.6885C31.7191 11.2207 31.7357 11.4097 31.7705 11.5859C31.8561 12.0193 32.0265 12.4318 32.2725 12.7988H32.2734C32.3731 12.9476 32.4943 13.0923 32.8408 13.499C33.6358 14.4318 34.1626 15.0384 34.4775 15.6973C35.1736 17.1537 35.1736 18.8463 34.4775 20.3027C34.1626 20.9616 33.6358 21.5682 32.8408 22.501C32.4942 22.9077 32.3722 23.0523 32.2725 23.2012C32.0265 23.5682 31.8561 23.9806 31.7705 24.4141C31.7357 24.5903 31.7191 24.7794 31.6768 25.3115C31.5792 26.533 31.5231 27.3342 31.2803 28.0225V28.0234C30.7426 29.5454 29.5454 30.7426 28.0234 31.2803H28.0225C27.3342 31.5231 26.533 31.5792 25.3115 31.6768C24.7794 31.7191 24.5903 31.7357 24.4141 31.7705C23.9806 31.8561 23.5682 32.0265 23.2012 32.2725C23.0523 32.3722 22.9077 32.4942 22.501 32.8408C21.5682 33.6358 20.9616 34.1626 20.3027 34.4775C18.8463 35.1736 17.1537 35.1736 15.6973 34.4775C15.0384 34.1626 14.4318 33.6358 13.499 32.8408C13.0923 32.4943 12.9476 32.3731 12.7988 32.2734V32.2725C12.4318 32.0265 12.0193 31.8561 11.5859 31.7705C11.4097 31.7357 11.2207 31.7191 10.6885 31.6768C9.46702 31.5792 8.66581 31.5231 7.97754 31.2803H7.97656C6.45462 30.7426 5.25736 29.5454 4.71973 28.0234C4.47654 27.3349 4.42074 26.5331 4.32324 25.3115C4.28073 24.7788 4.26426 24.5901 4.22949 24.4141C4.14388 23.9806 3.9735 23.5682 3.72754 23.2012C3.6276 23.0521 3.50562 22.9075 3.15918 22.501C2.36432 21.5682 1.83736 20.9616 1.52246 20.3027C0.826398 18.8463 0.826396 17.1537 1.52246 15.6973C1.83735 15.0384 2.36433 14.4318 3.15918 13.499C3.50577 13.0923 3.62764 12.9479 3.72754 12.7988C3.97351 12.4318 4.14388 12.0194 4.22949 11.5859C4.26426 11.4099 4.28073 11.2212 4.32324 10.6885C4.42074 9.46689 4.47653 8.66506 4.71973 7.97656C5.25737 6.45463 6.45463 5.25737 7.97656 4.71973C8.66506 4.47653 9.46689 4.42074 10.6885 4.32324C11.2212 4.28073 11.4099 4.26426 11.5859 4.22949C12.0194 4.14388 12.4318 3.97351 12.7988 3.72754C12.9479 3.62764 13.0923 3.50576 13.499 3.15918C14.4318 2.36433 15.0384 1.83735 15.6973 1.52246ZM24.29 13.4463C24.1721 13.3287 23.9811 13.3286 23.8633 13.4463L15.3955 21.9141L12.1367 18.6553C12.0187 18.5374 11.827 18.5373 11.709 18.6553C11.5913 18.7732 11.5919 18.9649 11.71 19.083L15.1816 22.5547C15.2996 22.6726 15.4912 22.6728 15.6094 22.5547L24.29 13.874C24.4081 13.756 24.4081 13.5643 24.29 13.4463Z" fill="#2EBFCA" stroke="#FAFAFA" stroke-width="2"/>
                                        </svg> -->
                                    </span>
                                    <!-- <p>Ayobamidele Shola</p> -->
                                </div>
                            </div>
                            <div class="details-kid-holder mt-5" v-if="activeKid">
                                <div class="form-group">
                                    <h3>{{activeKid.firstname}} {{ activeKid.lastname }}</h3>
                                    <h4>Full Name</h4>
                                </div>
                                <div class="form-group">
                                    <h3>{{activeKid.date_of_birth}}</h3>
                                    <h4>Date of Birth</h4>
                                </div>
                                <div class="form-group">
                                    <h3 style="text-transform: capitalize;">{{activeKid.gender == 'f' ? 'Female': 'Male'}}</h3>
                                    <h4>Gender</h4>
                                </div>
                                <div class="form-group">
                                    <h3>{{activeKid.school.school_name}}</h3>
                                    <h4>school Name</h4>
                                </div>
                                <!-- <div class="form-group">
                                    <h3>Grade 4</h3>
                                    <h4>Class/Grade</h4>
                                </div> -->
                                <div class="form-group d-none">
                                    <h3>January 10th 2001</h3>
                                    <h4>Location/city</h4>
                                </div>
                            </div>
                        </div>

                       
            
                        <div class="form-group close-btn container">
                            <button class="btn closee" data-dismiss="modal" aria-label="Close">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import moment from "moment";
import $ from "jquery";
export default {
    name: "KidDetails",
    components: {
        PageLoader,
    },

    data() {
        return {
            activeKid: null,
        };
    },
    mounted() {
        this.activeKid = JSON.parse(localStorage.getItem('kidDetails'));
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
        goBack() {
            this.$router.back();
        },
    }
};
</script>


<style scoped lang="scss">
.title-modal {
    font-family: Nunito;
    font-weight: 800;
    font-size: 20px;
    line-height: 24px;
    color: #1C2B3A;
}
.profile-image {
    margin-top: 40px;
    position: relative;
    width: fit-content;
    margin: auto;
    img {
        width: 90px;
        height: 90px;
        object-fit: cover;
        border-radius: 24px;
        cursor: pointer;
        background: #f2efef;
    }
    p {
        margin-top: 20px;
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
        color: #4B4B4F;
        text-align: center;
    }
    span {
        position: absolute;
        right: 22px;
        top: 44px;
    }

}

.details-kid-holder {
    background: #ffffff;
    border-radius: 20px;
    padding: 10px 15px 0;
    .form-group {
        border-bottom: 1px solid #F5F7FA;
        h3 {
            font-family: Lato;
            font-weight: 600;
            font-size: 18px;
            text-align: left;
            line-height: 26px;
            color: #1C2B3A;
        }
        h4 {
            font-family: Lato;
            font-weight: 400;
            font-size: 15px;
            line-height: 24px;
            color: #5D6F7C;
            text-align: left;
        }
    }
}

.close-btn {
    margin-bottom: 2rem;
    .closee {
        border: 1px solid #2EBFCA;
        color: #2EBFCA;
        background: #ffffff;
        outline: 0;
        box-shadow: none;
        width: 100%;
    }
}
</style>